(() => {
  const root=document.querySelector('[data-contact-channels]');
  const form=root?.querySelector('#AlphaContactForm');
  const whatsapp=root?.querySelector('[data-contact-whatsapp]');
  if(!form||!whatsapp)return;
  const prepare=()=>{
    for(const id of ['AlphaContactName','AlphaContactEmail','AlphaContactMessage']){
      const input=form.querySelector('#'+id);
      if(input)input.value=input.value.trim();
    }
    return form.reportValidity();
  };
  const line=id=>{
    const input=form.querySelector('#'+id);
    if(!input?.value.trim())return '';
    const label=input.labels?.[0]?.textContent.replace(/\s*\*\s*$/,'').trim()||'';
    return label+': '+input.value.trim();
  };
  form.addEventListener('submit',event=>{if(!prepare())event.preventDefault();});
  whatsapp.addEventListener('click',()=>{
    if(!prepare())return;
    const fields=['AlphaContactSubject','AlphaContactName','AlphaContactEmail','AlphaContactOrder','AlphaContactReference','AlphaContactDimensions','AlphaContactCountry'];
    const message=[root.dataset.storeName,...fields.map(line).filter(Boolean),'',line('AlphaContactMessage')].join('\n');
    const url=new URL('https://wa.me/'+root.dataset.whatsapp);
    url.searchParams.set('text',message);
    window.open(url.href,'_blank','noopener,noreferrer');
  });
  whatsapp.disabled=false;
})();
